import axios from "axios";

export const getTickerPriceService = async (symbols = []) => {
  return await axios.get(
    `${
      process.env.REACT_APP_BINANCE_API_BASE
    }v3/ticker/24hr?symbols=${JSON.stringify(symbols)}`
  );
};
